import {Payload} from "../../../../../core/service/payload/payload";
import {PersonSavePayload} from "../../../../../person/impl/service/payload/personSave.payload";

export class PartnerSavePartnerPersonPayload implements Payload{
    typeValue: string;
    // FIXME type me
    person: PersonSavePayload;
    id: number;
}